import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-side-nav-bar',
    templateUrl: './side-nav-bar.component.html',
    standalone: false
})
export class SideNavBarComponent {
  @Output() public navigationToggle: EventEmitter<any> = new EventEmitter<any>();
  @Input() public showSideNav: boolean;

  public toggleNavigation(): void {
    this.navigationToggle.emit();
  }
}
